import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "../../../models/common";

import http from "../../../common/http-commons";
import { IAddOnsCombineSetup } from "../../../models/AddOns/Accounting/AddOnsCombineSetup";

export const AddOnsCombineSetupService = {
	getLoginAccount: async (
		AddOnsCombineSetupPageName: string,
		clientId: string,
	): Promise<IAddOnsCombineSetup | IServerError | IResponse | null | any> => {
		if (!AddOnsCombineSetupPageName) return null;
		if (!clientId) return null;
		try {
			const response: AxiosResponse<IAddOnsCombineSetup> =
				await http.get<IAddOnsCombineSetup>(
					`/v1/${
						AddOnsCombineSetupPageName === "net_suite"
							? "net-suite"
							: AddOnsCombineSetupPageName === "zoho_books"
								? "zoho-books"
								: AddOnsCombineSetupPageName === "quick_books"
									? "quick-books"
									: AddOnsCombineSetupPageName
					}/login?company_id=${clientId}`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			return {
				status: false,
				message: errorMessage,
			};
		}
	},
	getAddOnsCombineSetupById: async (
		AddOnsCombineSetupPageName: string,
		clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<IAddOnsCombineSetup | IServerError | IResponse | null | any> => {
		if (!AddOnsCombineSetupPageName) return null;
		if (!clientId) return null;
		try {
			const response: AxiosResponse<IAddOnsCombineSetup> =
				await http.get<IAddOnsCombineSetup>(
					`/v1/add-ons/setup/${clientId}/?add_ones_type=${
						AddOnsCombineSetupPageName === "net_suite"
							? "net-suite"
							: AddOnsCombineSetupPageName === "zoho_books"
								? "zoho-books"
								: AddOnsCombineSetupPageName === "quick_books"
									? "quick-books"
									: AddOnsCombineSetupPageName
					}`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any,
	): Promise<IAddOnsCombineSetup | IServerError | IResponse | any> => {
		const screenTag = requestPayload.addOnsCombineSetuPageName;
		const clientId = requestPayload.clientId;
		const organizationId = requestPayload.organizationId;
		console.log("screenTag", screenTag);

		try {
			const response: AxiosResponse<IAddOnsCombineSetup> =
				await http.post<IAddOnsCombineSetup>(
					`/v1/${
						// screenTag === "net_suite"
						// 	? `net_suite-schedule-and-time/connect?company_id=${clientId}`
						// 	: // url change later
						screenTag === "toggl"
							? `toggl-schedule-and-time/connect?company_id=${clientId}`
							: screenTag === "agendrix"
								? `agendrix-schedule-and-time/employees/import?company_id=${clientId}`
								: screenTag === "when_i_work"
									? `when-i-work-schedule-and-time/login?company_id=${clientId}`
									: screenTag === "swipe_clock"
										? `swipe-clock-schedule-and-time/connect?company_id=${clientId}`
										: screenTag === "easy_work_force"
											? `easy-work-force-schedule-and-time/connect?company_id=${clientId}`
											: screenTag === "quick_books_time"
												? `quick-books-schedule-and-time/login?company_id=${clientId}`
												: screenTag === "work_flow_max"
													? `work-flow-max-schedule-and-time/connect?company_id=${clientId}`
													: screenTag === "seven_shifts"
														? `7-shifts-schedule-and-time/login?company_id=${clientId}`
														: screenTag === "seven_shifts"
															? `7-shifts-schedule-and-time/login?company_id=${clientId}`
															: screenTag === "hr_wize"
																? `hrwize-hr/connect?company_id=${clientId}`
																: screenTag === "workable"
																	? `workable-hr/employees/import?company_id=${clientId}`
																	: screenTag
					}`,
					requestPayload,
				);

			if (response.status === 200) {
				return response;
			} else if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 404) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				// requestPayload.navigateToLogout("/logout");
				// return {
				// 	status: false,
				// 	message: "UnAuthrized",
				// };
				return axiosError.response;
			} else if (axiosError && axiosError.status === 404) {
				return axiosError.response;
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delAddOnsCombineSetup: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		const screenTag = delPayload.addOnsCombineSetuPageName;
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/${
					screenTag === "net_suite"
						? "net-suite"
						: screenTag === "zoho_books"
							? "zoho-books"
							: screenTag === "quick_books"
								? "quick-books"
								: screenTag
				}-combine-setup/${delPayload.clientId}/`,
			);

			if (response.status === 204) {
				return "Setup has been deleted successfully";
			} else if (response.status === 200) {
				return "Setup has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getAccountSettingsDDL: async (
		AddOnsCombineSetupPageName: string,
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		if (!AddOnsCombineSetupPageName) return null;
		if (!clientId) return null;
		try {
			const response: AxiosResponse<any[]> = await http.get<any[]>(
				`/v1/${
					AddOnsCombineSetupPageName === "net_suite"
						? "net-suite"
						: AddOnsCombineSetupPageName === "zoho_books"
							? "zoho-books"
							: AddOnsCombineSetupPageName === "quick_books"
								? "quick-books"
								: AddOnsCombineSetupPageName
				}/accounts?company_id=${clientId}`,
			);
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return response;
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},
};
